/// <reference path="../../apps/typings/customTds.d.ts"/>
import { BasicValidationService } from './BasicValidationService';

export class PrivacyConsentValidationService<T extends BasicAppDefinition> extends BasicValidationService<T> {
	protected emailCheckName: string;
	protected phoneCheckName: string;

	constructor(app: { options: BasicAppOptions<T> }, forms: JQuery, cb: () => void = () => {
		//NOSONAR
	}) {
		super(app, forms, cb);
		this.emailCheckName = "Antragssteller.Datenverwendung.Email";
		this.phoneCheckName = "Antragssteller.Datenverwendung.Telefon";
	}

	public addCustomMethods(): void {
		super.addCustomMethods();
		$.validator.addMethod('commercialapproval', this.validatorCommercialApproval.bind(this));
	}

	protected validatorCommercialApproval(value: any, element: HTMLElement): boolean {
		const $email = this.$ctx.find(`input[name="${this.emailCheckName}"]`),
			$phone = this.$ctx.find(`input[name="${this.phoneCheckName}"]`);
		if (($email.is(':checked') || $phone.is(':checked')) && !$(element).is(':checked')) {
			return false;
		}
		return true;
	}
}